var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-check-container" },
    [
      _c("div", { staticClass: "ai-header-banner" }, [
        _c("div", { staticClass: "banner-overlay" }),
        _c("div", { staticClass: "banner-content" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "banner-actions" },
            [
              _c(
                "el-button",
                {
                  staticClass: "gradient-btn green-btn",
                  attrs: { type: "success", icon: "el-icon-plus" },
                  on: { click: _vm.showCreateDynamicCronjobDialog },
                },
                [_vm._v("\n          Thêm cấu hình mới\n        ")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ai-stats-grid" }, [
        _c("div", { staticClass: "stat-card blue" }, [
          _vm._m(1),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [_vm._v("Tổng số trang")]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.totalPage)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card green" }, [
          _vm._m(2),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Đang nạp (trang này)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.listAutoRunConfigurationAdmin.length)),
            ]),
          ]),
        ]),
        _vm._m(3),
      ]),
      _c(
        "div",
        { staticClass: "glass-card mb-4" },
        [
          _c(
            "el-form",
            {
              staticClass: "modern-filter-form",
              attrs: { inline: true, model: _vm.dataSearch },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Tên cấu hình" } },
                [
                  _c("el-input", {
                    staticClass: "modern-input",
                    attrs: {
                      clearable: "",
                      placeholder: "Nhập tên cấu hình...",
                      "prefix-icon": "el-icon-search",
                    },
                    on: { clear: _vm.handleSearch },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleSearch.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.dataSearch.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "name", $$v)
                      },
                      expression: "dataSearch.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Loại cấu hình" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-input",
                      attrs: {
                        clearable: "",
                        placeholder: "Tất cả",
                        loading: _vm.loadingCategories,
                      },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.dataSearch.category,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "category", $$v)
                        },
                        expression: "dataSearch.category",
                      },
                    },
                    _vm._l(_vm.categoryOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("Tìm kiếm")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "glass-card table-container" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingData,
                  expression: "loadingData",
                },
              ],
              staticClass: "modern-table",
              attrs: {
                data: _vm.listAutoRunConfigurationAdmin,
                "element-loading-text":
                  "Đang tải danh sách cấu hình chạy tự động...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.7)",
                border: "",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.calculateStt,
                  label: "STT",
                  width: "55",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "Tên hoạt động",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "click-in-row-btn",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.detailAction(row)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-document",
                              staticStyle: { "margin-right": "4px" },
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(row.name) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Mã cấu hình (Job Key)",
                  "min-width": "160",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("code", { staticClass: "code-badge" }, [
                          _vm._v(_vm._s(row.jobKey)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Loại cấu hình",
                  "min-width": "130",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { size: "small", type: "info" } },
                          [_vm._v(_vm._s(_vm.getCategoryLabel(row.category)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Biểu thức thời gian (Cron)",
                  "min-width": "180",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "cron-badge" }, [
                          _c("i", {
                            staticClass: "el-icon-time",
                            staticStyle: {
                              color: "#64748b",
                              "margin-right": "4px",
                            },
                          }),
                          _c("code", [_vm._v(_vm._s(row.cronExpression))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "description",
                  label: "Mô tả cấu hình",
                  "min-width": "250",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticClass: "desc-text" }, [
                          _vm._v(_vm._s(row.description || "—")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  width: "180",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpdate(row)
                              },
                            },
                          },
                          [_vm._v("\n            Sửa\n          ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(row)
                              },
                            },
                          },
                          [_vm._v("\n            Xóa\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper mt-3 flex justify-center" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.dataSearch.page,
                  "page-sizes": _vm.listSizePage,
                  "page-size": _vm.dataSearch.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.paginationTotal,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentPageChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.dataSearch, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.dataSearch, "page", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("CreateDynamicCronjobDialog", {
        attrs: {
          isCreateDynamicCronjob: _vm.isCreateDynamicCronjob,
          "category-options": _vm.categoryOptions,
        },
        on: { close: _vm.handleCloseCreateDynamicCronjobDialog },
      }),
      _c("UpdateDynamicCronjobDialog", {
        attrs: {
          id: _vm.id,
          showDetail: _vm.showDetail,
          isUpdateDynamicCronjob: _vm.isUpdateDynamicCronjob,
          "category-options": _vm.categoryOptions,
        },
        on: { close: _vm.handleCloseUpdateDynamicCronjobDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-left" }, [
      _c("div", { staticClass: "ai-icon-pulse" }, [
        _c("i", { staticClass: "el-icon-time" }),
      ]),
      _c("div", [
        _c("h1", { staticClass: "banner-title" }, [
          _vm._v("CẤU HÌNH TỰ ĐỘNG CHẠY (CRONJOB)"),
        ]),
        _c("p", { staticClass: "banner-subtitle" }, [
          _vm._v(
            "Quản lý, lên lịch và cấu hình biểu thức thời gian chạy tự động (Cron Expression) cho các tác vụ nền."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-setting" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-cpu" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-card purple" }, [
      _c("div", { staticClass: "stat-icon" }, [
        _c("i", { staticClass: "el-icon-date" }),
      ]),
      _c("div", { staticClass: "stat-info" }, [
        _c("p", { staticClass: "stat-label" }, [_vm._v("Mẫu biểu thức")]),
        _c("h3", { staticClass: "stat-value" }, [_vm._v("Cron Expression")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }